import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import SectionContainer from '../SectionContainer';

import css from './NewsLetter.module.css';

export default function NewsLetter(props) {
  const [hasEmailValue, setHasEmailValue] = useState(false);

  useEffect(() => {

    const createSendScript = document.createElement('script');
    createSendScript.src = 'https://js.createsend1.com/javascript/copypastesubscribeformlogic.js';
    createSendScript.async = true;

    document.body.appendChild(createSendScript);

    return () => {
      document.body.removeChild(createSendScript);
    };
  }, []);

  const { sectionId, className, rootClassName, appearance, options } = props;

  return (
    <SectionContainer
      id={sectionId}
      className={className || css.root}
      rootClassName={rootClassName}
      appearance={appearance}
      contentClassName={css.newsletterContentContainer}
      options={options}
    >
      <div className={css.embedRoot}>
        <div className={css.centerContainer}>
          <div className={css.titleWrap}>
            <h1 className={css.title}>Stay in the Loop</h1>
            <p className={css.description}>Be the first to discover new gear, featured locations, and ways to get outside.</p>
          </div>
          <div className={css.formCard}>
            <form
              className={`js-cm-form ${css.embedForm}`}
              id="subForm"
              action="CreatesendAn Error Occurred"
              method="post"
              data-id="2BE4EF332AA2E32596E38B640E905619EAF937FBC0ECD10CA61FA9736904A063FDC63A7CD43C496A4925C2FA2C243CB3FEA5D82537E8A7AE12DA8DD2EA49FCB3"
            >
              <div className={css.fieldsWrap}>
                <div className={css.fieldRow}>
                  <label
                    className={classNames(css.label, { [css.labelHidden]: hasEmailValue })}
                    htmlFor="fieldEmail"
                  >
                    Enter your Email <span className={css.required}>*</span>
                  </label>
                  <input
                    className={`js-cm-email-input qa-input-email ${css.input}`}
                    autoComplete="email"
                    id="fieldEmail"
                    maxLength="200"
                    name="cm-triilyt-triilyt"
                    onInput={e => setHasEmailValue(e.target.value.length > 0)}
                    required
                    type="email"
                  />
                </div>
              </div>
              <button className={`js-cm-submit-button ${css.submitButton}`} type="submit">
                Join The Community
                <span>
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.525391 4.60833H8.69206M5.19206 0.524994L9.27539 4.60833L5.19206 8.69166" stroke="white" stroke-width="1.05" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </SectionContainer>
  );
}